module.exports = __webpack_public_path__ + "static/media/JeremiahBell-resume.2bc5259b.pdf";